import { createMetric } from './metrics.service';
import { getPlayer } from './queries';

const graphql = {
  createMetric,
  getPlayer,
};

export default graphql;
